const BOARD_NAVIGATION_PHASES = Object.freeze({
  IDLE: "idle",
  CHECKING: "checking",
  READY: "ready",
  ERROR: "error",
});

const BOARD_NAVIGATION_DIRECTIONS = Object.freeze({
  NONE: "none",
  TOP_PLAYS_TO_LEAGUE: "top-plays-to-league",
  LEAGUE_TO_TOP_PLAYS: "league-to-top-plays",
  WITHIN_BOARD: "within-board",
});

const normalizeBoardSport = (value) => String(value || "").toLowerCase();
const isTopPlaysBoardSport = (value) => normalizeBoardSport(value) === "topplays";

const getBoardTransitionDirection = (transition) => {
  if (!transition) {
    return BOARD_NAVIGATION_DIRECTIONS.NONE;
  }

  const sourceIsTopPlays = isTopPlaysBoardSport(transition.sourceSport);
  const destinationIsTopPlays = isTopPlaysBoardSport(transition.sport);
  if (sourceIsTopPlays && !destinationIsTopPlays) {
    return BOARD_NAVIGATION_DIRECTIONS.TOP_PLAYS_TO_LEAGUE;
  }
  if (!sourceIsTopPlays && destinationIsTopPlays) {
    return BOARD_NAVIGATION_DIRECTIONS.LEAGUE_TO_TOP_PLAYS;
  }
  return BOARD_NAVIGATION_DIRECTIONS.WITHIN_BOARD;
};

const selectBoardNavigationView = (state = createInitialBoardNavigationState(), currentSport = "", currentStat = "") => {
  const pendingSport = normalizeBoardSport(state.transition?.sport);
  const pendingStat = String(state.transition?.stat || "");
  const normalizedCurrentSport = normalizeBoardSport(currentSport);
  const direction = getBoardTransitionDirection(state.transition);
  const completedDirection = state.phase === BOARD_NAVIGATION_PHASES.READY
    ? getBoardTransitionDirection(state.completedTransition)
    : BOARD_NAVIGATION_DIRECTIONS.NONE;

  return {
    pendingSport,
    pendingStat,
    selectedSport: pendingSport || normalizedCurrentSport,
    selectedStat: pendingSport === normalizedCurrentSport && pendingStat ? pendingStat : currentStat,
    direction,
    completedDirection,
    isChecking: state.phase === BOARD_NAVIGATION_PHASES.CHECKING,
    topPlaysHeroExiting: direction === BOARD_NAVIGATION_DIRECTIONS.TOP_PLAYS_TO_LEAGUE,
    topPlaysHeroEntering: completedDirection === BOARD_NAVIGATION_DIRECTIONS.LEAGUE_TO_TOP_PLAYS &&
      isTopPlaysBoardSport(currentSport),
  };
};

const createInitialBoardNavigationState = () => ({
  phase: BOARD_NAVIGATION_PHASES.IDLE,
  transition: null,
  completedTransition: null,
  snapshot: null,
  error: "",
});

const boardNavigationReducer = (state, action = {}) => {
  switch (action.type) {
    case "begin":
      return {
        ...state,
        phase: BOARD_NAVIGATION_PHASES.CHECKING,
        transition: action.transition || null,
        error: "",
      };
    case "ready":
      if (state.transition?.requestToken !== action.requestToken) {
        return state;
      }
      return {
        phase: BOARD_NAVIGATION_PHASES.READY,
        transition: null,
        completedTransition: state.transition,
        snapshot: action.snapshot || null,
        error: "",
      };
    case "error":
      if (state.transition?.requestToken !== action.requestToken) {
        return state;
      }
      return {
        ...state,
        phase: BOARD_NAVIGATION_PHASES.ERROR,
        transition: null,
        error: String(action.error || "unknown").slice(0, 80),
      };
    case "reset":
      return createInitialBoardNavigationState();
    default:
      return state;
  }
};

module.exports = {
  BOARD_NAVIGATION_DIRECTIONS,
  BOARD_NAVIGATION_PHASES,
  boardNavigationReducer,
  createInitialBoardNavigationState,
  getBoardTransitionDirection,
  selectBoardNavigationView,
};
